import { ICardElementWithChildren } from "backend/model/model";
import getValues from "backend/values";
import * as wf from "client-api-workflow";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { useQuery } from "react-query";
import usePeriods from "../../hooks/model/usePeriods";
import usePeriodLevels from "../model/usePeriodLevels";

const useMyTasks = (
  type: "completed" | "coming" | "current",
  context?: string,
  page?: number,
  rowsPerPage?: number
) => {
  const { data: periods, isLoading } = usePeriods();
  const { data: periodLevels } = usePeriodLevels();
  const ctx = useAppContext();

  return useQuery(
    JSON.stringify(["data-mytasks-workflow", type, context, page, rowsPerPage]),
    () => {
      const params: any = {
        modelId: ctx.fullModelId,
        include: type,
      };
      if (page) params.page = page;
      if (rowsPerPage) params.rowsPerPage = rowsPerPage;

      if (context === "mytasks" || context === "wfinput") {
        // optimization: do not fetch values, those are not needed in these views
        return wf.getMyTasks(params).then((taskData) => {
          return taskData!.map((task) => {
            return {
              ...({
                id: task.measureId,
                name: task.measurename,
                typename: "",
                symbol: "",
                owner: "",
                topelement: "",
                periodlevel: "",
                periodlevelname: "",
                children: [],
              } as ICardElementWithChildren),
              workflowState: task,
            };
          });
        });
      } else {
        return wf.getMyTasks(params).then((taskData) => {
          return Promise.all(
            taskData!.map((task) => {
              return getValues(
                task.measureId,
                (periods || []).filter((n) => n.name === task.period),
                false,
                periodLevels!
              ).then((list) => {
                return {
                  ...list[0],
                  workflowState: task,
                };
              });
            })
          );
        });
      }
    },
    {
      enabled: (periods || []).length > 0 && !!periodLevels,
      cacheTime: context === "wfinput" ? 10 * 60 * 1000 : 20 * 1000,
      staleTime: context === "wfinput" ? 10 * 60 * 1000 : 20 * 1000,
    }
  );
};

export default useMyTasks;
